import type { Paginated, StoreListItem } from '@flux/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client.js';
import { queryKeys } from '@/lib/query/keys.js';

function fetchStoresList(): Promise<Paginated<StoreListItem>> {
  return apiFetch<Paginated<StoreListItem>>('/api/stores', { query: { page: 1, pageSize: 200 } });
}

/** Liste des boutiques — alimente le sélecteur de boutique (`02` §0). Peu de boutiques : une seule page suffit. */
export function useStoresList(): UseQueryResult<Paginated<StoreListItem>> {
  return useQuery({
    queryKey: queryKeys.stores.list(),
    queryFn: fetchStoresList,
    staleTime: 60_000,
  });
}
